import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BackPageBtn from "../BackButton/BackPageBtn";
import toast from "react-hot-toast";
import HomeServices from "../../Services/HomeServices";
import DataTable from "react-data-table-component";

const ManagePaymentsForServices = () => {
  const location = useLocation();

  const user = location?.state?.user;
  const serviceId = location?.state?.serviceId;
  const [userDataToMakePayment, setUserDataToMakePayment] = useState({
    userId: user?.userId,
    assignServiceId: serviceId,
    paidAmount: "",
    mode: "",
  });
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [fetchPaymentHistoryLoading, setFetchPaymentHistoryLoading] =
    useState(false);
  const [makingPaymentLoading, setMakingPaymentLoading] = useState(false);

  const fetchPaymentHistory = async () => {
    setFetchPaymentHistoryLoading(true);
    const res = await HomeServices.getUserPaymentHistory();
    if (res && res?.status) {
      setPaymentHistory(res?.data?.reverse());
      setFetchPaymentHistoryLoading(false);
    } else {
      setFetchPaymentHistoryLoading(false);
      toast.error("Failed to fetch payment history");
    }
    console.log("Amit Roy", res);
  };
  useEffect(() => {
    fetchPaymentHistory();
  }, []);

  const handleSubmit = async () => {
    if (!userDataToMakePayment?.paidAmount || !userDataToMakePayment?.mode) {
      return toast.error("Please enter all the details");
    }
    setMakingPaymentLoading(true);
    console.log(userDataToMakePayment);
    await HomeServices.userPayment(userDataToMakePayment)
      .then((res) => {
        if (res && res?.status) {
          toast.success("Payment Successfull!");
          setMakingPaymentLoading(false);
          fetchPaymentHistory();
          setUserDataToMakePayment((prev) => ({ ...prev, paidAmount: "" }));
        } else {
          toast.error(res?.message || "Payment is notr Successfull");
          setMakingPaymentLoading(false);
        }
      })
      .catch((err) => {
        toast.error(err?.message || "An Error Occurred");
        console.error("err", err);
        setMakingPaymentLoading(false);
      });
  };

  function formatReadableDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      wrap: true,
      center: true,
    },
    {
      name: "Paid Amount",
      selector: (row) => row?.paidAmount,
      wrap: true,
      center: true,
    },
    {
      name: "Date",
      selector: (row) => <div> {formatReadableDate(row?.createdAt)}</div>,
      wrap: true,
      center: true,
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-end mt-2">
        <div className="form-header">
          <BackPageBtn backLink="/users" />
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area">
            <h1
              style={{
                color: "#ff9c00",
                fontSize: "25px",
                fontWeight: "600",
                marginBottom: "10px",
              }}
            >
              Make Payment
            </h1>
            <div className="row mt-4">
              <div className="col">
                <label htmlFor="formGroupExampleInput">Amount</label>
                <input
                  value={userDataToMakePayment?.paidAmount}
                  type="text"
                  className="form-control"
                  placeholder="Enter Amount"
                  name="name"
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) {
                      setUserDataToMakePayment((prev) => ({
                        ...prev,
                        paidAmount: Number(e.target.value),
                      }));
                    }
                  }}
                />
              </div>
              <div style={{ marginTop: "15px" }}>
                <label htmlFor="formGroupExampleInput">Mode</label>
                <select
                  className="form-control"
                  onChange={(e) => {
                    setUserDataToMakePayment((prev) => ({
                      ...prev,
                      mode: e.target.value,
                    }));
                  }}
                >
                  <option>-------- Select Mode --------</option>
                  <option value="Online">Online</option>
                  <option value="Cash">Cash</option>
                  <option value="Net Banking">Net Banking</option>
                </select>
              </div>
              <div class="col-12 ">
                <button
                  disabled={makingPaymentLoading}
                  type="button"
                  onClick={() => handleSubmit()}
                  class="btn btn-primaryb mt-5 mb-4 addBlogBn"
                  style={{
                    background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                    color: "#fff",
                  }}
                >
                  {makingPaymentLoading ? "Loading..." : "Submit"}
                </button>
              </div>
            </div>
            <div>
              <h4 style={{ color: "#ff9000" }}>Payment History</h4>
            </div>
            <div>
              <DataTable
                columns={columns}
                data={paymentHistory}
                pagination
                progressPending={fetchPaymentHistoryLoading}
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ManagePaymentsForServices;
